var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VisitLink',[_c('div',{staticClass:"inline-block px-4 py-4 font-bold leading-none text-black no-underline rounded-sm offerCtaCell whitespace-nowrap"},[_c('span',[_vm._v(_vm._s(_vm.value.offer.ctaText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }